import { setIn } from 'lodash-redux-immutability';
import { createReducer } from "../helpers/create-reducer";

const actions = {
    'UI.PENDING': (state, {payload}) => {
        return setIn(state, [payload.id], !!payload.value);
    }
};

export default createReducer({}, actions);